import { render, staticRenderFns } from "./our-partners.vue?vue&type=template&id=70b2a7f8&scoped=true&"
import script from "./our-partners.vue?vue&type=script&lang=js&"
export * from "./our-partners.vue?vue&type=script&lang=js&"
import style0 from "./our-partners.vue?vue&type=style&index=0&id=70b2a7f8&scoped=true&lang=css&"
import style1 from "./our-partners.vue?vue&type=style&index=1&id=70b2a7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2a7f8",
  null
  
)

export default component.exports